import {OrderDto} from "./OrderDto";
import {AlteredProductDto} from "./AlteredProductDto";

export class UpdateConfigurationDto {
    constructor(public Order: OrderDto, public Product: AlteredProductDto, public ConfigurationId: number) {
    }
}